import { colors } from '~/layout';
import * as lib from '~/dependencies';

export const Container = lib.styled.div`
  ${(props: any) =>
    props.maxHeight === 'auto'
      ? 'flex: 1; min-height: 0;'
      : `height: ${props.maxHeight}px;`};
  overflow-y: auto;
  padding-bottom: 0px;
  transition: padding-bottom 0.15s ease-out;

  .list--header {
    position: relative!important;
    top: 0px!important;
    background-color: ${colors.white};
    margin: 5px 0px 5px 0px!important;

    .line-header {
      position: relative!important;
      top: 0px!important;
      margin: 0!important;
    }
  }
`;

export const CenterMessage = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 70% !important;
  height: 600px;
  color: ${colors.darkGray02} !important;
`;
